<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false" :needPopMenu="true" :canbeEdit="true"
            @cellClick="cellClick" @pagechange="pagechange"
          :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'flexIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        browsList: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'flexcode', fieldtype: 'C', title: '表格名',calculExpr:'', editRender: { name: 'input'}},
          { field: 'flexname', fieldtype: 'C', title: '表格说明',calculExpr:'',editRender: { name: 'input'}},
          { field: 'flexbrowsid', fieldtype: 'C', title: '数据助手',calculExpr:'',editRender: { name: 'ElSelect', option: [],props: {clearable: true}}},
          { field: 'flexremark', fieldtype: 'C',title: '备注',calculExpr:'',editRender: { name: 'input'}}
        ],
        flex: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delFlex())
      this.$on('FIELD', () => this.setFlexCol())
      this.$on('GEN', () => this.setDocgen())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getBrowsList()
      this.getFlexList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async init() {
        this.menuid = this.$route.query.menuid
        this.list = []
        this.browsList = []
        this.flex = {}
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.flex = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },

      async getBrowsList() {
        this.browsList = await request({
          url: '/kfgl/brows/getBrowsIdList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        console.log(this.browsList)
        this.browsList.splice(0,0, {
          label: '无',
          value: null
        })
        this.cols[3].editRender.options = this.browsList
      },
      async delFlex () {
        if (!this.flex.flexid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/flex/delFlex',
            method: "post",
            data: this.flex
          })
          if (data.issuccess===1) {
            this.getFlexList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async setFlexCol () {
        if (!this.flex.flexid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.$router.push({name: 'flexcolForm', params: {form: this.flex}})
      },
      async setDocgen () {
        if (!this.flex.flexid) {
          this.$message.warning('请选择一条数据!')
          return
        }
        this.$router.push({name: 'docgenIndex', params: {form: this.flex}})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.flex = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getFlexList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        let data = await request({
          url: '/kfgl/flex/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getFlexList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getFlexList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/flex/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
